export default __webpack_public_path__ + "static/media/apple-pay.1b5fe358.svg";